import {useId, useState} from "react";
import {css} from "@panda/css";

import {ResponsiveModal} from "@pg-design/modal-module";
import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {useAppSelector} from "../../store/hooks";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {SIGNED_OUT_RESERVATION_AUTH_STATE} from "../constants/reservation_constants";
import {useReservationFlow} from "../hooks/use_reservation_flow";
import {useStartReservationRegistration} from "../hooks/use_start_reservation_registration";
import {IReservationRequest} from "../types/IReservationRequest";
import {getReservationCloseHandlers} from "../utils/get_reservation_close_handlers";
import {getReservationModalProps} from "../utils/get_reservation_modal_props";
import {ReservationStepsContent} from "./ReservationStepsContent";

interface IProps {
    request: IReservationRequest;
    // the placement of the registration that led to the reservation - when omitted, the placement of the reservation button is reported
    authPlacement?: AmplitudeAuthPlacement | null;
    // called once the exit animation has finished
    onClose: () => void;
}

export const ReservationModal = (props: IProps) => {
    const {request, authPlacement, onClose} = props;

    const titleId = useId();
    const descriptionId = useId();
    const [isCloseRequested, setIsCloseRequested] = useState(false);
    const viewType = useAppSelector((state) => state.viewType.current);
    const startReservationRegistration = useStartReservationRegistration();
    // the confirmation follows the placement of the request, also one handed over from the unlock choice after an expired session
    const {state, isSubmitting, codeStepProps, confirmedStepProps, reset} = useReservationFlow({
        request,
        authPlacement,
        autoStart: true,
        // only a rejected session ends up here, so the user already has an account
        onUnauthenticated: (unauthenticatedRequest) =>
            startReservationRegistration(unauthenticatedRequest, SIGNED_OUT_RESERVATION_AUTH_STATE, {showLoginForm: true})
    });

    const step = state.status === "confirmed" ? "confirmed" : "code";
    // a request handed over from the unlock choice after an expired session keeps the events of its funnel
    const {close, confirmedClose} = getReservationCloseHandlers({
        request,
        isConfirmed: step === "confirmed",
        isSubmitting,
        isCloseRequested,
        trackingContext: {authPlacement, viewType},
        requestClose: () => setIsCloseRequested(true)
    });

    const handleAfterClose = () => {
        reset();

        if (isCloseRequested) {
            onClose();
        }
    };

    return (
        <ResponsiveModal
            isOpen={!isCloseRequested}
            onClose={close}
            onAfterClose={handleAfterClose}
            {...getReservationModalProps({step, isInitiating: codeStepProps.isInitiating, titleId, descriptionId})}
        >
            {step === "code" && (
                <ResponsiveModal.Header divider={false} className={headerStyle}>
                    <ResponsiveModal.CloseButton dataTestId={RP_RESERVATION_TEST_IDS.CLOSE_BUTTON} />
                </ResponsiveModal.Header>
            )}

            <ResponsiveModal.Body>
                <ReservationStepsContent
                    step={step}
                    titleId={titleId}
                    descriptionId={descriptionId}
                    codeStepProps={codeStepProps}
                    confirmedStepProps={confirmedStepProps}
                    onClose={close}
                    onConfirmedClose={confirmedClose}
                />
            </ResponsiveModal.Body>
        </ResponsiveModal>
    );
};

const headerStyle = css({
    display: "flex",
    justifyContent: "flex-end",
    px: 2,
    pt: 1.5,
    md: {
        px: 3
    }
});
import {useId, useState} from "react";
import {css} from "@panda/css";

import {ResponsiveModal} from "@pg-design/modal-module";
import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {useAppSelector} from "../../store/hooks";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {SIGNED_OUT_RESERVATION_AUTH_STATE} from "../constants/reservation_constants";
import {useReservationFlow} from "../hooks/use_reservation_flow";
import {useStartReservationRegistration} from "../hooks/use_start_reservation_registration";
import {IReservationRequest} from "../types/IReservationRequest";
import {getReservationCloseHandlers} from "../utils/get_reservation_close_handlers";
import {getReservationModalProps} from "../utils/get_reservation_modal_props";
import {ReservationStepsContent} from "./ReservationStepsContent";

interface IProps {
    request: IReservationRequest;
    // the placement of the registration that led to the reservation - when omitted, the placement of the reservation button is reported
    authPlacement?: AmplitudeAuthPlacement | null;
    // called once the exit animation has finished
    onClose: () => void;
}

export const ReservationModal = (props: IProps) => {
    const {request, authPlacement, onClose} = props;

    const titleId = useId();
    const descriptionId = useId();
    const [isCloseRequested, setIsCloseRequested] = useState(false);
    const viewType = useAppSelector((state) => state.viewType.current);
    const startReservationRegistration = useStartReservationRegistration();
    // the confirmation follows the placement of the request, also one handed over from the unlock choice after an expired session
    const {state, isSubmitting, codeStepProps, confirmedStepProps, reset} = useReservationFlow({
        request,
        authPlacement,
        autoStart: true,
        // only a rejected session ends up here, so the user already has an account
        onUnauthenticated: (unauthenticatedRequest) =>
            startReservationRegistration(unauthenticatedRequest, SIGNED_OUT_RESERVATION_AUTH_STATE, {showLoginForm: true})
    });

    const step = state.status === "confirmed" ? "confirmed" : "code";
    // a request handed over from the unlock choice after an expired session keeps the events of its funnel
    const {close, confirmedClose} = getReservationCloseHandlers({
        request,
        isConfirmed: step === "confirmed",
        isSubmitting,
        isCloseRequested,
        trackingContext: {authPlacement, viewType},
        requestClose: () => setIsCloseRequested(true)
    });

    const handleAfterClose = () => {
        reset();

        if (isCloseRequested) {
            onClose();
        }
    };

    return (
        <ResponsiveModal
            isOpen={!isCloseRequested}
            onClose={close}
            onAfterClose={handleAfterClose}
            {...getReservationModalProps({step, isInitiating: codeStepProps.isInitiating, titleId, descriptionId})}
        >
            {step === "code" && (
                <ResponsiveModal.Header divider={false} className={headerStyle}>
                    <ResponsiveModal.CloseButton dataTestId={RP_RESERVATION_TEST_IDS.CLOSE_BUTTON} />
                </ResponsiveModal.Header>
            )}

            <ResponsiveModal.Body>
                <ReservationStepsContent
                    step={step}
                    titleId={titleId}
                    descriptionId={descriptionId}
                    codeStepProps={codeStepProps}
                    confirmedStepProps={confirmedStepProps}
                    onClose={close}
                    onConfirmedClose={confirmedClose}
                />
            </ResponsiveModal.Body>
        </ResponsiveModal>
    );
};

const headerStyle = css({
    display: "flex",
    justifyContent: "flex-end",
    px: 2,
    pt: 1.5,
    md: {
        px: 3
    }
});
